import moment from "moment";

import { BTSelectItem } from "types/apiResponse/apiResponse";

export type PayrollSettingsFormActions =
    | undefined
    | "save"
    | "disconnect"
    | "createAccount"
    | "selectCompany";

export const GustoImageLink = "/images/Marketplace/btGusto.svg";

export enum PayrollAccountError {
    Unknown = 0,
    UserAlreadyExists = 1,
    MultipleEmailAddresses = 2,
    InvalidEmailAddress = 3,
}

export class PayrollSettingsEntity {
    constructor(data: any) {
        this.authUrl = data.authUrl;
        this.learnMoreUrl = data.learnMoreUrl;
        this.payScheduleId = data.payScheduleId;
        this.connectedByName = data.connectedByName;
        this.companyUuid = data.companyUuid;
        this.isUserConnected = data.isUserConnected;
        this.errorMessage = data.errorMessage;
        this.key = data.key;
        this.planRequiredForPayroll = data.planRequiredForPayroll;

        if (data.connectedDate) {
            this.connectedDate = moment(data.connectedDate);
        }

        if (data.paySchedules && data.paySchedules.value && data.paySchedules.value.length > 0) {
            this.paySchedules = data.paySchedules.value.map((j: any) => new BTSelectItem(j));
        }
    }

    companyUuid: string;
    isUserConnected: boolean;
    connectedByName: string;
    connectedDate: moment.Moment;
    payScheduleId: number;
    authUrl: string;
    learnMoreUrl: string;
    errorMessage: string;
    paySchedules?: BTSelectItem[];
    key: string;
    planRequiredForPayroll: string;
}

export class CreatePayrollAccountResponse {
    constructor(data: any) {
        this.redirectURL = data.redirectURL;
        if (data.error !== null) {
            this.error = data.error;
        }
    }

    redirectURL: string;
    error?: PayrollAccountError;
}

export class PayrollUpdateResponse {
    constructor(data: any) {
        if (data.errorList && data.errorList.length > 0) {
            this.errorList = data.errorList;
        }

        if (data.failedItems && data.failedItems.length > 0) {
            this.failedItems = data.failedItems;
        }

        if (data.warningList && data.warningList.length > 0) {
            this.warningList = data.warningList;
        }
    }

    errorList?: string[];
    failedItems?: number[];
    warningList?: string[];
}

export class SelectPayrollsResponse {
    constructor(data: any) {
        this.payrollKey = data.payrollKey;

        if (data.gustoPayrolls && data.gustoPayrolls.value && data.gustoPayrolls.value.length > 0) {
            this.gustoPayrolls = data.gustoPayrolls.value.map((j: any) => new BTSelectItem(j));

            if (this.payrollKey == null && this.gustoPayrolls && this.gustoPayrolls.length > 0) {
                this.payrollKey = this.gustoPayrolls[0].value;
            }
        }
    }

    gustoPayrolls?: BTSelectItem[];
    payrollKey?: string;
}
